export default __webpack_public_path__ + "static/media/true-skate@2x.78d4490f.webp";